import { Metadata } from '@redwoodjs/web';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';
import { AgTab, AgTabs } from 'src/components/ui/AgTabs';
import AccountsTab from './accounts/AccountsTab';
import PreferencesTab from './preferences/PreferencesTab';
import QBOSettingsTab from './quickbooks/QBOSettingsTab';

export enum AccountingTabs {
  PREFERENCES = 'preferences',
  ACCOUNTS = 'accounts',
  QBO_SETTINGS = 'qbo-settings',
}

export default function AccountingSettingsPage() {
  return (
    <>
      <Metadata title="Accounting Settings" />
      <PageHeader pageType={PageType.AccountingSettings} />
      <PageBody>
        <AgTabs queryParam="tab">
          <AgTab id={AccountingTabs.ACCOUNTS} label="Accounts">
            <AccountsTab />
          </AgTab>
          <AgTab id={AccountingTabs.PREFERENCES} label="Preferences">
            <PreferencesTab />
          </AgTab>
          <AgTab id={AccountingTabs.QBO_SETTINGS} label="QBO Settings">
            <QBOSettingsTab />
          </AgTab>
        </AgTabs>
      </PageBody>
    </>
  );
}
